import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as $script from 'scriptjs';
import { OeAppService } from '../oe-app.service';

@Component({
  selector: 'lp2-writing-feedback-request-modal',
  templateUrl: './writing-feedback-request-modal.component.html',
  styleUrls: ['./writing-feedback-request-modal.component.scss'],
})
export class WritingFeedbackRequestModalComponent implements OnInit {
  $script = $script;

  formId = '2110766709';
  private eParam = 'B6fiTn%2BRcO4w2DWOGwAYKwN041FG5t1H6i5F2Wdvk90%3D';
  private embedManagerSdkUrl = `https://fs11.formsite.com/include/form/embedManager.js?${this.formId}`;
  private embedManagerKey = `https://fs11.formsite.com/res/showFormEmbed?EParam=${this.eParam}&${this.formId}`;

  constructor(public activeModal: NgbActiveModal, private oeAppService: OeAppService) {}

  ngOnInit() {
    const { firstName, lastName, email, academicLevel, id, nativeLang } = this.oeAppService.getData('person');
    const embedManagerOptions = {
      key: this.embedManagerKey,
      width: '100%',
      mobileResponsive: true,
      prePopulate: {
        1: `${firstName} ${lastName}`,
        2: id,
        3: academicLevel,
        4: email,
        5: nativeLang,
      },
    };

    this.loadEmbedManagerSdk().then(
      () => {
        this.initializeEmbedManager(embedManagerOptions);
      },
      err => {
        console.error('Error loading EmbedManager SDK', err);
      },
    );
  }

  loadEmbedManagerSdk() {
    return new Promise((resolve, reject) => {
      this.$script(this.embedManagerSdkUrl, resolve, reject);
    });
  }

  initializeEmbedManager(embedManagerOptions) {
    if (!(window as any).EmbedManager) {
      console.error('EmbedManager SDK is not loaded!');
      return;
    }

    (window as any).EmbedManager.embed(embedManagerOptions);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/writing-feedback-request-modal/writing-feedback-request-modal.component.ts